import { useAuthService } from '@/modules/auth/auth.service'

export function fetchAuthDataMiddleware() {
  const { fetchUser } = useAuthService()
  return fetchUser()
}
